/**
 * AI Service Base URL
 *
 * Central constant for all frontend → AI service calls.
 * Uses VITE_AI_BASE_URL env var when set (e.g., ai-dev.jdsimplified.com for dev).
 * Falls back to production MIG URL.
 */
export const AI_BASE_URL = import.meta.env.VITE_AI_BASE_URL || 'https://ai.jdsimplified.com';
